type EngineSetupHandoffOptions = {
  pairingCode: string;
  serverUrl?: string;
};

const DEFAULT_ENGINE_SETUP_SERVER_URL = 'https://api.oracord.com';

export function engineGuidedSetupCommand({
  pairingCode,
  serverUrl = DEFAULT_ENGINE_SETUP_SERVER_URL,
}: EngineSetupHandoffOptions) {
  const normalizedCode = pairingCode.trim();
  const normalizedServer = normalizeEngineSetupServerUrl(serverUrl);
  return `oracord-engine setup --code ${normalizedCode} --server ${normalizedServer}`;
}

export function engineSetupLink({
  pairingCode,
  serverUrl = DEFAULT_ENGINE_SETUP_SERVER_URL,
}: EngineSetupHandoffOptions) {
  const params = new URLSearchParams({
    code: pairingCode.trim(),
    server: normalizeEngineSetupServerUrl(serverUrl),
  });

  return `oracord-engine://setup?${params.toString()}`;
}

export function engineStartServiceLink(intervalSeconds = 30) {
  const safeInterval = Number.isFinite(intervalSeconds) && intervalSeconds >= 10 ? Math.floor(intervalSeconds) : 30;
  return `oracord-engine://start-service?interval=${safeInterval}`;
}

function normalizeEngineSetupServerUrl(serverUrl: string) {
  return serverUrl.trim().replace(/\/+$/, '');
}
